<template>
  <div id="vue-container">
    <!-- <test-app /> -->
    <stub />
    <!-- <v-app> -->
    <div
      class="page-wrapper"
      :style="windowParams"
    >
      <router-view />
    </div>
    <global-popup v-if="isShowGlobalPopup" />
    <pass-strength-popup v-if="isShowPassStrengthPopup" />
    <payment-plans v-if="isShowPaymentPage" />
    <students-page v-if="isShowStudentsPage" />
    <tooltip-popup
      v-if="isShowPricingPopup"
      :config="getConfig"
    />

    <copy-settings-popup
      v-if="isOpenCopyPopup"
    />

    <progress-bar />
    <!-- <app-gallery /> -->
    <!-- <app-filter-old /> -->
    <app-filter />
    <massChangePopup />
    <reload-modal />
    <newProjectFromTemplatePopup />
    <currency-popup />
    <columns-config-bar />
    <upgrade-subscription-popup />
    <message-us-popup />

    <task-resources-popup />
    <task-resources-preview-popup />
    <task-custom-column-preview-popup />

    <portal-target name="popup" />
    <portal-target name="confirm-popup" />
    <portal-target name="right-popup" />
    <portal-target name="task-settings" />
    <portal-target name="portal-columns-sidebar" />
    <portal-target name="portal-filter-sidebar" />
    <portal-target name="vgp-date-range-picker" />
    <vue-gallery />
    <maintenance-notification />
    <learning-center-support-floating-icon />
    <!-- </v-app> -->
  </div>
</template>

<script>
import app from '$$app';
// import appFilterOld from './views/filterOld/filter.vue';
import appFilter from './views/filter/main.vue';
import massChangePopup from './views/massChangeWindow/massChangePopup.vue';
import CurrencyPopup from './views/common/VueComponents/popups/currencyPopup/currencyPopup.vue';
import reloadModal from './views/modals/reloadModal/reloadModal.vue';
import stub from './views/stubs/stubPage.vue';
import projectsModel from '$$projectModel';
import progressBar from './views/progressBar/main.vue';
import newProjectFromTemplatePopup from './views/templatePopups/newProjectFromTemplatePopup.vue';
import settingErrors from './helpers/settingErrors';
import keyboardModule from './components/keyboard';
import resourcesOverload from './components/resourcesOverload';
import CopySettingsPopup from './views/copyPaste/copyPasteSettings.vue';
import columnsConfigBar from './views/columnsConfigBar/main.vue';
import TaskResourcesPopup from './views/taskResourcesPopups/taskResourcesPopup.vue';
import TaskResourcesPreviewPopup from './views/taskResourcesPopups/taskResourcesPreviewPopup.vue';
import TaskCustomColumnPreviewPopup from './views/taskCustomColumnPopups/taskCustomColumnPreviewPopup.vue';
import upgradeSubscriptionPopup from './views/paymentPlans/upgradePlanPopup/upgradePlanPopup.vue';
import MessageUsPopup from './views/contactUsPopup/MessageUsPopup.vue';
import TestApp from './test.vue';
import pricingHelper from '$$helpers/pricingHelper';
import LearningCenterSupportFloatingIcon from './views/learningCenter/New/components/tabs/supportTab/learningCenterSupportFloatingIcon.vue';

export default {
  name: 'App',
  components: {
    CopySettingsPopup,
    // appFilterOld,
    appFilter,
    massChangePopup,
    CurrencyPopup,
    reloadModal,
    stub,
    progressBar,
    newProjectFromTemplatePopup,
    columnsConfigBar,
    TaskResourcesPopup,
    TaskResourcesPreviewPopup,
    TaskCustomColumnPreviewPopup,
    upgradeSubscriptionPopup,
    TestApp,
    LearningCenterSupportFloatingIcon,
    MessageUsPopup,
  },
  computed: {
    windowParams() {
      const params = this.$store.getters.getWindowParams;

      return params;
    },
    isShowPermissionPopup() {
      return this.$store.getters['profileSettings/isShowPermissionPopup'];
    },
    isShowGlobalPopup() {
      return this.$store.getters['globalPopup/isShowGlobalPopup'];
    },
    isShowPassStrengthPopup() {
      return this.$store.getters['passStrengthPopup/isShowPassStrengthPopup'];
    },
    isShowPricingPopup() {
      return this.$store.getters['tooltip/isShowPopup'];
    },
    isShowPaymentPage() {
      return this.$store.getters['paymentClient/isShowPaymentPage'];
    },
    isShowStudentsPage() {
      return this.$store.getters['paymentClient/isShowStudentsPage'];
    },
    getConfig() {
      return this.$store.getters['tooltip/getConfig'];
    },
    isOpenCopyPopup() {
      return this.$store.getters['copyPaste/isOpenCopyPopup'];
    },
  },
  watch: {
    $route() {
      this.$store.commit('tooltip/showPricingPopup', false);
      this.$nextTick(() => this.updateWindowParams());
    },
    '$route.params.projectId': {
      handler(val) {
        if (val) {
          const projectData = projectsModel.getProjectDataById(+val);

          if (!projectData.is_archived) {
            _.delay(() => {
              this.$store.dispatch('attachments/fetchAttachmentsByProjectIds', { projectIds: val });
              this.$store.dispatch('comments/fetchCommentsByProjectIds', { projectIds: val });
            }, 500);
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.addSocketListeners();
    window.addEventListener('resize', this.updateWindowParams);

    // this.$store.dispatch('paymentModel/loadData');
    this.$store.state.appMode.isBase && this.$store.dispatch('comments/fetchCommentsActions');

    // need fill teamsStore -> settingErrors. Global errors
    settingErrors();
    this.resetTimeTracking();
  },
  mounted() {
    this.$nextTick(() => {
      this.updateWindowParams();
      this.loadProgress();
      this.initKeyboard();
      this.initOverloadCache();
    });
  },
  beforeUnmount() {
    this.removeSocketListeners();
    window.removeEventListener('resize', this.updateWindowParams);
    keyboardModule.destroy();
  },
  methods: {
    updateWindowParams() {
      this.$store.dispatch('updateWindowParams', {});
    },
    loadProgress() {
      this.$store.dispatch('progress/loadData');
    },
    initKeyboard() {
      keyboardModule.init();
    },
    initOverloadCache() {
      resourcesOverload.init();
    },
    copyTasksCallback(data) {
      this.$store.dispatch('copyPaste/afterPasteTasks', Object.assign(data, { isSpecialPaste: false }));
    },
    specialPasteCallback(data) {
      this.$store.dispatch('copyPaste/afterPasteTasks', Object.assign(data, { isSpecialPaste: true }));
    },
    exportLinkCallback(data) {
      const link = document.createElement('a');

      link.href = `/api/export/${data.fileToken}`;
      link.download = data.name;
      link.click();
    },
    resetTimeTracking() {
      const tariffTimeTrackingAccess = pricingHelper.checkPricingAccess('time_tracking');
      const userTimeTrackingActivity = _.find(user.activity, o => o.name === 'timeTracker');
      const trackerData = userTimeTrackingActivity?.settings ? JSON.parse(userTimeTrackingActivity.settings) : null;

      if (!tariffTimeTrackingAccess && trackerData) {
        this.$store.dispatch('user/updateActivitySettings', {
          activityName: 'timeTracker',
          settings: false,
        });
      }
    },
    addSocketListeners() {
      app.socket.on('copy:tasks', this.copyTasksCallback);
      app.socket.on('copy:specialPaste', this.specialPasteCallback);
      app.socket.on('export:link', this.exportLinkCallback);
    },
    removeSocketListeners() {
      app.socket.off('copy:tasks', this.copyTasksCallback);
      app.socket.off('copy:specialPaste', this.specialPasteCallback);
      app.socket.off('export:link', this.exportLinkCallback);
    },
  },
};
</script>

<style lang="less" scoped>
  .page-wrapper {
    position: absolute;
    z-index: 9;
    background: #fff;
  }

  .gantt-scroll {
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      visibility: hidden;
      border-radius: 4px;
      background: fade(#000, 40%);
      cursor: pointer;
    }

    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }
</style>
